import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import heroImg from '../Images/about-hero.webp'
import BreadcrumbMain from "../Components/BreadcrumbMain";
import { blogsData } from "../Blog";
import { baldivisServices, joondalupServices, leedervilleServices } from "../Data";

const Sitemap=()=>{
    useEffect(() => {
            document.title =
              "Sitemap | LDL Settlement Services Perth";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Explore the complete sitemap of LDL Settlement Services and quickly access our settlement services, buyer & seller guides, blogs, FAQs, and contact pages across Perth & Western Australia."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://ldlsettlementservices.com.au/sitemap");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Sitemap | LDL Settlement Services Perth"
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Explore the complete sitemap of LDL Settlement Services and quickly access our settlement services, buyer & seller guides, blogs, FAQs, and contact pages across Perth & Western Australia."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/sitemap");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/home-img.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Sitemap | LDL Settlement Services Perth"
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Explore the complete sitemap of LDL Settlement Services and quickly access our settlement services, buyer & seller guides, blogs, FAQs, and contact pages across Perth & Western Australia."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/home-img.webp"
            );
          }
          }, []);
    const sitemapData = [
    {
      heading: "Main Pages",
      links: [
        {
          title: "Home",
          path: "/",
        },
        {
          title: "About Us",
          path: "/about-us",
        },
        {
          title: "Services",
          path: "/services",
        },
        {
          title: "Blog",
          path: "/blog",
        },
        {
          title: "Contact Us",
          path: "/contact-us",
        },
        {
          title: "Get a Quote",
          path: "/get-a-quote",
        },
      ],
    },
    {
  heading: "Settlement Services",
  links: [
    {
      title: "Residential Settlements",
      path: "/services/residential-property-settlements",
    },
    {
      title: "Commercial Settlements",
      path: "/services/commercial-property-settlements",
    },
    {
      title: "New Title Applications",
      path: "/services/new-title-applications",
    },
    {
      title: "Family Transfers & Change of Name",
      path: "/services/family-transfers-change-of-name",
    },
    {
      title: "Subdivisions",
      path: "/services/subdivisions",
    },
    {
      title: "Strata Titles",
      path: "/services/strata-titles",
    },
    {
      title: "Private Sales",
      path: "/services/private-sales",
    },
    {
      title: "Survivorship Application",
      path: "/services/survivorship-applications",
    },
     {
      title: "Change of Trustees of Trusts",
      path: "/services/change-of-trustees-of-trusts",
    },
    {
      title: "Separation/ Divorce - Transfer pursuant to court orders",
      path: "/services/separation-divorce-property-transfers",
    },
    {
      title: "Transmission application",
      path: "/services/transmission-applications",
    },
  ],
},
    {
      heading: "For Buyers",
      links: [
        {
          title: "Buying Process",
          path: "/buyers/buying-process",
        },
        {
          title: "Costs Involved",
          path: "/buyers/costs-involved",
        },
        {
          title: "First Home Buyers",
          path: "/buyers/first-home-buyers",
        },
        {
          title: "FAQ’s For Buyers",
          path: "/buyers/faqs",
        },
        {
          title: "Pre-settlement Checklist",
          path: "/buyers/pre-settlement-checklist",
        },
      ],
    },

    {
      heading: "For Sellers",
      links: [
        {
          title: "Selling Process",
          path: "/sellers/selling-process",
        },
        {
          title: "Costs Involved",
          path: "/sellers/costs-involved",
        },
        {
          title: "Preparing Your Property",
          path: "/sellers/preparing-your-property",
        },
        {
          title: "FAQ’s For Sellers",
          path: "/sellers/faqs",
        },
         {
          title: "Pre-settlement Checklist",
          path: "/sellers/pre-settlement-checklist",
        },
      ],
    },
     {
  heading: "Baldivis",
  links: [
     {
      title: "Settlement Services in Baldiviis",
      path: "/services/baldivis",
    },
     ...baldivisServices.map((service) => ({
      title: service.heroTitle,
      path: `/services/baldivis/${service.slug}`,
    })),
  ],
},
 {
  heading: "Joondalup",
  links: [
    {
      title: "Settlement Services in Joondalup",
      path: "/services/joondalup",
    },

    ...joondalupServices.map((service) => ({
      title: service.heroTitle,
      path: `/services/joondalup/${service.slug}`,
    })),
  ],
},
 {
  heading: "Leederville",
  links: [
    {
      title: "Settlement Services in Leederville",
      path: "/services/leederville",
    },

    ...leedervilleServices.map((service) => ({
      title: service.heroTitle,
      path: `/services/leederville/${service.slug}`,
    })),
  ],
},
    {
      heading: "Legal Pages",
      links: [
        {
          title: "Privacy Policy",
          path: "/privacy-policy",
        },
        {
          title: "Terms & Conditions",
          path: "/terms-and-conditions",
        },
        {
          title: "Sitemap",
          path: "/sitemap",
        },
      ],
    },

   {
  heading: "Blog Pages",
  links: [...blogsData].reverse().map((blog) => ({
    title: blog.title,
    path: `/blog/${blog.slug}`,
  })),
},
  ];

   const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.85,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

    return(
        <>
         {/**HEADER */}
         <Header
        showBreadcrumb={true}
        pageName="Sitemap"
      />

      {/**HERO SECTION */}
       <BreadcrumbMain
      subTitle="SITEMAP"
      title="Explore Our Sitemap"
      description="Browse our complete website structure to quickly access settlement services, buyer and seller resources, property guides, FAQs, blogs, and important information designed to help you navigate property settlements across Perth and Western Australia with confidence."
      image={heroImg}
      showIcons={false}
    />

    {/**PAGES AND LINKS */}
     <section className="sitemap-section container">

        {/* TOP */}

        <motion.div
          className="services-top"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
        >

          <motion.h2
            className="section-heading center-heading"
            variants={fadeUp}
          >
            Explore Every Page Across
            <span> LDL Settlement Services</span>
          </motion.h2>

        </motion.div>

        {/* GRID */}

        <div className="sitemap-grid">

          {sitemapData.map((section, index) => (

           <motion.div
  className={`sitemap-card ${
    section.heading === "Blog Pages" ? "sitemap-blog-card" : ""
  }`}
              key={index}
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{
                once: true,
                amount: 0.2,
              }}
              variants={fadeUp}
              whileHover={{
                y: -6,
              }}
            >

              <h3 className="card-heading">
                {section.heading}
              </h3>

              <div className="sitemap-links">

                {section.links.map((item, i) => (

                  <Link
                    key={i}
                    to={item.path}
                    className="sitemap-link"
                  >

                    <span className="sitemap-arrow">
                      ❯
                    </span>

                    {item.title}

                  </Link>

                ))}

              </div>

            </motion.div>

          ))}

        </div>

      </section>
        </>
    )
}
export default Sitemap;